module.exports = __webpack_public_path__ + "static/media/icon-phone.a615d7d6.svg";